import React from "react";
import './styles.scss'
import {getTerminalColor} from "../../utils/getTerminalColor";

export default ({color}) => {
  return (
    <div
      className={`terminal-color terminal-color--`+ getTerminalColor(color)}
    />
  )
}
